import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppContext } from 'Context/ReactAppContext';
import { getFilters } from 'Store/booking/additional-accommodations/filters/filterUtils';
import { getAdditionalAccommodationsFilters } from 'Store/booking/booking.selector';
import { AdditionalAccommodationsLayer } from 'Components/widgets/additional-accommodations/layers/AdditionalAccommodationsLayer';
import {
  clearAdditionalAccommodations,
  fetchAdditionalAccommodations,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';
type Props = {
  onClose: () => void;
  onSubmit: (arg0: string | AccommodationArrangement) => void;
  processChangeAccommodation?: boolean;
  portalName?: string;
  product: ProductWithAccommodations;
  proposal: Proposal;
  streetViews?: Array<StreetViewWithAccommodationCategoryId>;
  switchOffers: (offers: Array<string>) => void;
};
export const MoreRooms = ({
  onClose,
  onSubmit,
  portalName,
  processChangeAccommodation = true,
  product,
  proposal,
  streetViews,
  switchOffers,
}: Props) => {
  const appContext = useAppContext();
  const dispatch = useDispatch();
  const [selectedRate, setSelectedRate] = useState(proposal.price.selectedRate);
  const filterValues = useSelector(getAdditionalAccommodationsFilters);
  const filters = getFilters(product, filterValues || []);
  useEffect(() => {
    dispatch(
      fetchAdditionalAccommodations({
        appContext,
        proposal,
        product,
        shouldPreselectFilters: false,
      }),
    );
    return () => {
      dispatch(clearAdditionalAccommodations());
    };
  }, []);
  const props = {
    filters,
    filterValues,
    onClose,
    onSubmit,
    portalName,
    processChangeAccommodation,
    product,
    proposal,
    selectedRate,
    setSelectedRate,
    streetViews,
    switchOffers,
  };
  return <AdditionalAccommodationsLayer {...props} />;
};
